import { SwipeableProps } from "./types"
import React from "react"
import { observer } from "mobx-react-lite"
import { SwipeableCore } from "./core"

const Swipeable: React.FC<SwipeableProps> = ({ item, actions, children, ...rest }) => {
  return actions ? (
    <SwipeableCore item={item} actions={actions.filter(({ visible }) => visible(item))} {...rest}>
      {children}
    </SwipeableCore>
  ) : (
    <>{children}</>
  )
}
export default observer(Swipeable)
